import { Fragment, useState, useEffect } from "react";
import "./user_bookmarks_content_component.scss";
import images from "../../../../utilities/images/images";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import axios from "axios";
import {
  url_40,
  url_39,
  url_77,
  url_106,
} from "../../../../custom_utilities/api_services";
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import userBookmarkActions from "../../../../redux/user_bookmark/action";
import userActivityActions from "../../../../redux/user_activity/action";
import InfiniteScroll from "react-infinite-scroll-component";

const UserBookmarksContentComponent = (props) => {
  let {
    history,
    options,
    startLoading,
    finishLoading,
    setOptions,
    setVideoData,
    setBookmarkQuestionList,
  } = props;

  const [state, setState] = useState({
    optionType: 1,
    pageNumber: 1,
    videosData: [],
    dppData: {},
    exerciseData: {},
    testData: [],
    videos: [],
    pyqData: [],
    homeworkData: {},
  });

  useEffect(() => {
    getInitialRenderData();
  }, []);

  const getInitialRenderData = () => {
    let optionType = options.option_type;
    setState((prevState) => ({ ...prevState, optionType: optionType }));

    switch (optionType) {
      case 1:
        getDppData();
        break;
      case 2:
        getExerciseData();
        break;
      case 3:
        getTestData();
        break;
      case 6:
        getPyqData();
        break;
      case 4:
        getVideosData();
        break;
      case 7:
        getHomeworkData();
        break;
      default:
        break;
    }
  };

  const getDppData = async () => {
    let data = {
      type: 2,
    };
    startLoading();
    try {
      const response = await axios.post(url_40, data);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          dppData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getHomeworkData = async () => {
    let data = {
      type: 7,
    };
    startLoading();
    try {
      const response = await axios.post(url_40, data);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          homeworkData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getExerciseData = async () => {
    let data = {
      type: 1,
    };
    startLoading();
    try {
      const response = await axios.post(url_40, data);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          exerciseData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getPyqData = async () => {
    let data = 6;
    const token =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyMjk2MjYsImV4cGlyZXNfYXQiOiIyMDIzLTEwLTE5IDEzOj11OjA4In0.KAt7B1KReAIocjR_SVHRHUWRr0gQn2gtAZa8otDN-ag";
    startLoading();
    try {
      const response = await axios.post(
        `${url_40}?type=${data}&Authorization=${token}`
      );
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          pyqData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getTestData = async () => {
    startLoading();
    try {
      const response = await axios.post(url_106);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          testData: [...response.data.data.ExamList],
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getVideosData = async () => {
    let data = {
      type: 4,
    };
    startLoading();
    try {
      const response = await axios.post(url_40, data);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          videos: [...response.data.data.VideoList.data],
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const renderOptions = () => {
    let optionType = state.optionType;
    switch (optionType) {
      case 1:
        return renderDppCollectionView();
      case 2:
        return renderExerciseCollectionView();
      case 3:
        return renderTestCollectionView();
      case 4:
        return renderVideoCollectionView();
      case 6:
        return renderPYQCollectionView();
      case 7:
        return renderHomeworkCollectionView();
      default:
        return null;
    }
  };

  const handleBookmarkPyqQuestion = async (pyqQuestionDetails) => {
    let allQuestionList = [...state.pyqData.AllQuestionList];

    let pyqQuestionIndex = allQuestionList.findIndex((element) => {
      return element.qid === pyqQuestionDetails.qid;
    });

    if (pyqQuestionIndex !== -1) {
      allQuestionList.splice(pyqQuestionIndex, 1);

      setState((prevState) => ({
        ...prevState,
        pyqData: {
          ...prevState.pyqData,
          AllQuestionList: allQuestionList,
        },
      }));
    } else {
      return;
    }

    let data = {
      type: 6,
      reference_id: pyqQuestionDetails.qid,
      status: 0,
    };

    try {
      await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBookmarkHomeworkQuestion = async (homeworkQuestionDetails) => {
    let allQuestionList = [...state.homeworkData.AllQuestionList];

    let homeworkQuestionIndex = allQuestionList.findIndex((element) => {
      return element.qid === homeworkQuestionDetails.qid;
    });

    if (homeworkQuestionIndex !== -1) {
      allQuestionList.splice(homeworkQuestionIndex, 1);

      setState((prevState) => ({
        ...prevState,
        homeworkData: {
          ...prevState.homeworkData,
          AllQuestionList: allQuestionList,
        },
      }));
    } else {
      return;
    }

    let data = {
      type: 7,
      reference_id: homeworkQuestionDetails.qid,
      status: 0,
    };

    try {
      await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBookmarkDppQuestion = async (dppQuestionDetails) => {
    let allQuestionList = [...state.dppData.AllQuestionList];

    let dppQuestionIndex = allQuestionList.findIndex((element) => {
      return element.qid === dppQuestionDetails.qid;
    });

    if (dppQuestionIndex !== -1) {
      allQuestionList.splice(dppQuestionIndex, 1);

      setState((prevState) => ({
        ...prevState,
        dppData: {
          ...prevState.dppData,
          AllQuestionList: allQuestionList,
        },
      }));
    } else {
      return;
    }

    let data = {
      type: 2,
      reference_id: dppQuestionDetails.qid,
      status: 0,
    };

    try {
      await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  const renderDppCollectionView = () => {
    return (
      <Fragment>
        <div className="dpp_collection_view_wrapper">
          <div className="dpp_collection_view_innner_wrapper">
            <div className="dpp_question_collection_wrapper">
              {!isEmpty(state.dppData) ? (
                state.dppData.AllQuestionList.length ? (
                  state.dppData.AllQuestionList.map((element, index) => {
                    return (
                      <div key={index} className="single_question_wrapper">
                        <div className="left_side_content_wrapper">
                          <div className="serial_number_wrapper">
                            <div className="text_content_wrapper">
                              <p className="text_content">{index + 1}.</p>
                            </div>
                          </div>
                          <div className="details_wrapper">
                            <div
                              className="text_content_wrapper"
                              dangerouslySetInnerHTML={renderQuestionText(
                                element.q_text
                              )}
                              onClick={() =>
                                handleStoreBookmarkDataInStorage("dpp")
                              }
                            ></div>
                          </div>
                        </div>
                        <div className="right_side_content_wrapper">
                          <div className="image_wrapper">
                            {element.is_saved ? (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkDppQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            ) : (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkDppQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : null
              ) : (
                <div className="not_bookmarks">
                  <div className="null_bkmark_inr">
                    <div className="img_wrp">
                      <img src={images.noBookmark} alt="DPP" />
                    </div>
                    <p>You haven't Bookmarked yet!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderHomeworkCollectionView = () => {
    return (
      <Fragment>
        <div className="homework_collection_view_wrapper">
          <div className="homework_collection_view_inner_wrapper">
            <div className="homework_question_collection_wrapper">
              {!isEmpty(state.homeworkData) ? (
                state.homeworkData.AllQuestionList.length ? (
                  state.homeworkData.AllQuestionList.map((element, index) => {
                    return (
                      <div key={index} className="single_question_wrapper">
                        <div className="left_side_content_wrapper">
                          <div className="serial_number_wrapper">
                            <div className="text_content_wrapper">
                              <p className="text_content">{index + 1}.</p>
                            </div>
                          </div>
                          <div className="details_wrapper">
                            <div
                              className="text_content_wrapper"
                              dangerouslySetInnerHTML={renderQuestionText(
                                element.q_text
                              )}
                              onClick={() =>
                                handleStoreBookmarkDataInStorage("homework")
                              }
                            ></div>
                          </div>
                        </div>
                        <div className="right_side_content_wrapper">
                          <div className="image_wrapper">
                            {element.is_saved ? (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkHomeworkQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            ) : (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkHomeworkQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : null
              ) : (
                <div className="not_bookmarks">
                  <div className="null_bkmark_inr">
                    <div className="img_wrp">
                      <img src={images.noBookmark} alt="Homework" />
                    </div>
                    <p>You haven't Bookmarked yet!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleBookmarkExerciseQuestion = async (exerciseQuestionDetails) => {
    let allQuestionList = [...state.exerciseData.AllQuestionList];

    let exerciseQuestionIndex = allQuestionList.findIndex((element) => {
      return element.qid === exerciseQuestionDetails.qid;
    });

    if (exerciseQuestionIndex !== -1) {
      allQuestionList.splice(exerciseQuestionIndex, 1);

      setState((prevState) => ({
        ...prevState,
        exerciseData: {
          ...prevState.exerciseData,
          AllQuestionList: allQuestionList,
        },
      }));
    } else {
      return;
    }

    let data = {
      type: 1,
      reference_id: exerciseQuestionDetails.qid,
      status: 0,
    };

    try {
      const response = await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  const renderQuestionText = (questionText) => {
    return { __html: questionText };
  };

  const renderExerciseCollectionView = () => {
    return (
      <Fragment>
        <div className="exercise_collection_view_wrapper">
          <div className="exercise_collection_view_innner_wrapper">
            <div className="exercise_question_collection_wrapper">
              {!isEmpty(state.exerciseData) ? (
                state.exerciseData.AllQuestionList.length ? (
                  state.exerciseData.AllQuestionList.map((element, index) => {
                    return (
                      <div key={index} className="single_question_wrapper">
                        <div className="left_side_content_wrapper">
                          <div className="serial_number_wrapper">
                            <div className="text_content_wrapper">
                              <p className="text_content">{index + 1}.</p>
                            </div>
                          </div>
                          <div className="details_wrapper">
                            <div
                              className="text_content_wrapper"
                              dangerouslySetInnerHTML={renderQuestionText(
                                element.q_text
                              )}
                              onClick={() =>
                                handleStoreBookmarkDataInStorage("exercise")
                              }
                            ></div>
                          </div>
                        </div>
                        <div className="right_side_content_wrapper">
                          <div className="image_wrapper">
                            {element.is_saved ? (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkExerciseQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            ) : (
                              <img
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkExerciseQuestion(element)
                                }
                                alt="bookmark-icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : null
              ) : (
                <div className="not_bookmarks">
                  <div className="null_bkmark_inr">
                    <div className="img_wrp">
                      <img src={images.noBookmark} alt="exercise" />
                    </div>
                    <p>You haven't Bookmarked yet!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleBookmarkTestQuestion = async (testQuestionDetails) => {
    let allQuestionList = [...state.testData];

    let testQuestionIndex = allQuestionList.findIndex((element) => {
      return element.qid === testQuestionDetails.qid;
    });

    if (testQuestionIndex !== -1) {
      allQuestionList.splice(testQuestionIndex, 1);

      setState((prevState) => ({
        ...prevState,
        testData: [...allQuestionList],
      }));
    } else {
      return;
    }

    let data = {
      paper_id: testQuestionDetails.paper_id,
      type: 3,
      reference_id: testQuestionDetails.qid,
      status: 0,
    };

    try {
      const response = await axios.post(url_77, data);
    } catch (error) {
      console.log(error);
    }
  };

  const renderTestCollectionView = () => {
    return (
      <Fragment>
        <div className="test_collection_view_wrapper">
          <div className="test_collection_view_innner_wrapper">
            <div className="test_question_collection_wrapper">
              {!isEmpty(state.testData) ? (
                state.testData.length ? (
                  state.testData.map((element, index) => {
                    return (
                      <div key={index} className="single_question_wrapper">
                        <div className="left_side_content_wrapper">
                          <div className="serial_number_wrapper">
                            <div className="text_content_wrapper">
                              <p className="text_content">{index + 1}.</p>
                            </div>
                          </div>
                          <div className="details_wrapper">
                            <div
                              className="text_content_wrapper"
                              dangerouslySetInnerHTML={renderQuestionText(
                                element.q_text
                              )}
                              onClick={() =>
                                handleStoreBookmarkDataInStorage("test")
                              }
                            ></div>
                          </div>
                        </div>
                        <div className="right_side_content_wrapper">
                          <div className="image_wrapper">
                            {element.is_saved ? (
                              <img
                                src={images.bookmark}
                                alt="bookmark-icon"
                                onClick={() =>
                                  handleBookmarkTestQuestion(element)
                                }
                              />
                            ) : (
                              <img
                                src={images.bookmark}
                                alt="bookmark-icon"
                                onClick={() =>
                                  handleBookmarkTestQuestion(element)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : null
              ) : (
                <div className="not_bookmarks">
                  <div className="null_bkmark_inr">
                    <div className="img_wrp">
                      <img src={images.noBookmark} alt="test" />
                    </div>
                    <p>You haven't Bookmarked yet!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleBookmarkVideo = async (videoDetails) => {
    let videoList = [...state.videos];

    let videoIndex = videoList.findIndex((element) => {
      return element.video_id === videoDetails.video_id;
    });

    if (videoIndex !== -1) {
      videoList.splice(videoIndex, 1);

      setState((prevState) => ({
        ...prevState,
        videos: [...videoList],
      }));
    } else {
      return;
    }

    let data = {
      type: 4,
      reference_id: videoDetails.video_id,
      status: 0,
    };

    try {
      const response = await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  let page_limit = 10;

  const fetchVideosData = async () => {
    let pageNo = Math.ceil(state.videos.length / page_limit) + 1;
    let data = {
      type: 4,
      page: pageNo,
    };
    startLoading();
    try {
      const response = await axios.post(url_40, data);
      if (
        response.data.status === 200 ||
        response.data.data.videoList.last_page
      ) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          videos: [...state.videos, ...response.data.data.VideoList.data],
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const fetchData = () => {
    fetchVideosData();
  };

  const renderVideoCollectionView = () => {
    return (
      <Fragment>
        <div className="video_collection_view_wrapper">
          <div className="video_collection_view_innner_wrapper">
            <div
              id="parentScrollDiv"
              className="videosListBox"
              style={{
                height: "59vh",
                overflow: "auto",
                padding: "8px",
              }}
            >
              <InfiniteScroll
                dataLength={state.videos.length}
                next={fetchData}
                hasMore={true}
                scrollableTarget="parentScrollDiv"
              >
                <div className="videos_collection_wrapper">
                  {!isEmpty(state.videos) ? (
                    state.videos.length ? (
                      state.videos.map((element, index) => {
                        return (
                          <div
                            key={index}
                            className="user-dashboard-single_video_wrapper"
                          >
                            <div
                              className="left_side_content_wrapper"
                              onClick={() =>
                                handleStoreDataInStorage("videos", element)
                              }
                            >
                              <div className="image_wrapper">
                                <img src={element.thumnail} alt="" />
                              </div>
                            </div>
                            <div className="right_side_content_wrapper">
                              <div className="right_side_content_wrapper_top">
                                <div
                                  className="text_content_wrapper_1"
                                  onClick={() =>
                                    handleStoreDataInStorage("videos", element)
                                  }
                                >
                                  <p className="text_content_1">
                                    {element.video_title}
                                  </p>
                                </div>
                                <div className="image_wrapper">
                                  {element.IsSaved ? (
                                    <img
                                      src={images.bookmark}
                                      onClick={() =>
                                        handleBookmarkVideo(element)
                                      }
                                      alt="bookmark-icon"
                                    />
                                  ) : (
                                    <img
                                      src={images.bookmark}
                                      onClick={() =>
                                        handleBookmarkVideo(element)
                                      }
                                      alt="bookmark-icon"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="text_content_wrapper_2">
                                <p className="text_content_2">
                                  by {element.name}
                                </p>
                                <div className="label_content_wrapper">
                                  <label className="rating_wrapper">
                                    <span className="rating-icon">
                                      <img
                                        src={images.rating}
                                        alt="rating-icon"
                                      />
                                    </span>
                                    <span className="rating">
                                      {element.video_rating}
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="sub_content_wrapper">
                                <div className="right_side_content_wrapper">
                                  <button
                                    onClick={() =>
                                      handleStoreDataInStorage(
                                        "videos",
                                        element
                                      )
                                    }
                                  >
                                    Watch Now
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="not_bookmarks">
                        <div className="null_bkmark_inr">
                          <div className="img_wrp">
                            <img src={images.noBookmark} alt="Video" />
                          </div>
                          <p>You haven't Bookmarked yet!</p>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="not_bookmarks">
                      <div className="null_bkmark_inr">
                        <div className="img_wrp">
                          <img src={images.noBookmark} alt="exercise" />
                        </div>
                        <p>You haven't Bookmarked yet!</p>
                      </div>
                    </div>
                  )}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderPYQCollectionView = () => {
    return (
      <Fragment>
        <div className="test_collection_view_wrapper">
          <div className="test_collection_view_innner_wrapper">
            <div className="test_question_collection_wrapper">
              {!isEmpty(state.pyqData) ? (
                state.pyqData.AllQuestionList.length ? (
                  state.pyqData.AllQuestionList.map((element, index) => {
                    return (
                      <div key={index} className="single_question_wrapper">
                        <div className="left_side_content_wrapper">
                          <div className="serial_number_wrapper">
                            <div className="text_content_wrapper">
                              <p className="text_content">{index + 1}.</p>
                            </div>
                          </div>
                          <div className="details_wrapper">
                            <div
                              className=""
                              dangerouslySetInnerHTML={renderQuestionText(
                                element.q_text
                              )}
                              onClick={() =>
                                handleStoreBookmarkDataInStorage("pyq")
                              }
                            ></div>
                          </div>
                        </div>
                        <div className="right_side_content_wrapper">
                          <div className="image_wrapper">
                            {element.is_saved ? (
                              <img
                                alt=""
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkPyqQuestion(element)
                                }
                              />
                            ) : (
                              <img
                                alt=""
                                src={images.bookmark}
                                onClick={() =>
                                  handleBookmarkPyqQuestion(element)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="not_bookmarks">
                    <div className="null_bkmark_inr">
                      <div className="img_wrp">
                        <img src={images.noBookmark} alt="PYQ" />
                      </div>
                      <p>You haven't Bookmarked yet!</p>
                    </div>
                  </div>
                )
              ) : (
                <div className="not_bookmarks">
                  <div className="null_bkmark_inr">
                    <div className="img_wrp">
                      <img src={images.noBookmark} alt="PYQ" />
                    </div>
                    <p>You haven't Bookmarked yet!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleStoreDataInStorage = (type, data) => {
    if (data.is_paid === 0) {
      switch (type) {
        case "videos":
          data.redirectedFrom = "activity";
          setVideoData(data);
          history.push("/videos");
          break;
        default:
          break;
      }
    } else {
      alert("You haven't purchased a plan. Please purchase it from store.");
      history.push("/store");
    }
  };

  const handleStoreBookmarkDataInStorage = (type) => {
    let { testQuestionDetails } = state;
    switch (type) {
      case "dpp":
        setBookmarkQuestionList(testQuestionDetails);
        history.push({
          pathname: "/bookmark_questions",
          state: { type: type },
        });
        break;
      case "exercise":
        setBookmarkQuestionList(testQuestionDetails);
        history.push({
          pathname: "/bookmark_questions",
          state: { type: type },
        });
        break;
      case "pyq":
        setBookmarkQuestionList(testQuestionDetails);
        history.push({
          pathname: "/bookmark_questions",
          state: { type: type },
        });
        break;
      case "test":
        setBookmarkQuestionList(testQuestionDetails);
        history.push({
          pathname: "/bookmark_test_questions",
          state: { type: type },
        });
        break;
      case "homework":
        setBookmarkQuestionList(testQuestionDetails);
        history.push({
          pathname: "/bookmark_questions",
          state: { type: type },
        });
        break;
      default:
        break;
    }
  };

  const handleChangeOptions = (event) => {
    let { value } = event.target;

    switch (value) {
      case "dpp":
        setState((prevState) => ({
          ...prevState,
          optionType: 1,
          pageNumber: 1,
        }));
        setOptions(1);
        getDppData();
        break;
      case "homework":
        setState((prevState) => ({
          ...prevState,
          optionType: 7,
          pageNumber: 1,
        }));
        setOptions(7);
        getHomeworkData();
        break;
      case "exercise":
        setState((prevState) => ({
          ...prevState,
          optionType: 2,
          pageNumber: 1,
        }));
        setOptions(2);
        getExerciseData();
        break;
      case "test":
        setState((prevState) => ({
          ...prevState,
          optionType: 3,
          pageNumber: 1,
        }));
        setOptions(3);
        getTestData();
        break;
      case "pyq":
        setState((prevState) => ({
          ...prevState,
          optionType: 6,
          pageNumber: 1,
        }));
        setOptions(6);
        getPyqData();
        break;
      case "video":
        setState((prevState) => ({
          ...prevState,
          optionType: 4,
          pageNumber: 1,
        }));
        setOptions(4);
        getVideosData();
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="userBookmarksContentComponent_wrapper">
        <div className="container">
          <div className="userBookmarksContentComponent_inner_wrapper">
            <div className="sec_2_wrapper">
              <div className="sec_2_inner_wrapper">
                <div className="sub_content_wrapper_1">
                  <div className="bookmark_option_collection_wrapper">
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="dpp_bookmark"
                        name="bookmark_option"
                        value="dpp"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 1}
                      />
                      <label htmlFor="dpp_bookmark">DPP</label>
                    </div>
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="exercise_bookmark"
                        name="bookmark_option"
                        value="exercise"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 2}
                      />
                      <label htmlFor="exercise_bookmark">Exercise</label>
                    </div>
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="homework_bookmark"
                        name="bookmark_option"
                        value="homework"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 7}
                      />
                      <label htmlFor="homework_bookmark">Homework</label>
                    </div>
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="test_bookmark"
                        name="bookmark_option"
                        value="test"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 3}
                      />
                      <label htmlFor="test_bookmark">Test</label>
                    </div>
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="video_bookmark"
                        name="bookmark_option"
                        value="video"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 4}
                      />
                      <label htmlFor="video_bookmark">Video</label>
                    </div>
                    <div className="single_select_bookmark_option">
                      <input
                        type="radio"
                        id="pyq_bookmark"
                        name="bookmark_option"
                        value="pyq"
                        onChange={(event) => handleChangeOptions(event)}
                        checked={state.optionType === 6}
                      />
                      <label htmlFor="pyq_bookmark">PYQ</label>
                    </div>
                  </div>
                </div>
                <div className="sub_content_wrapper_2">{renderOptions()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    options: state.userBookmarkData.options,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setOptions: (payload) => {
      dispatch(userBookmarkActions.setOptions(payload));
    },
    setVideoData: (payload) => {
      dispatch(userActivityActions.setVideoData(payload));
    },
    setBookmarkQuestionList: (payload) => {
      dispatch(userBookmarkActions.setBookmarkQuestionList(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBookmarksContentComponent);
